import { BRAND_NAME } from './meta.js';
import { fetchExtraProductOfferInfo } from './fetch-extra-product-offer-info.js';

/**
 * @typedef {Object} UserData
 * @property {string} name
 * @property {string} email
 */

/**
 * @typedef {Object} ItemData
 * @property {string} productId
 * @property {string} id
 * @property {string} name
 * @property {string} price
 * @property {string} variant
 */

/**
 * 
 * @param {ItemData} itemData
 * @param {string} orderId
 * @param {UserData} userData
 * @returns  {Promise<Object>}
 */
export function createDetailReserve(itemData, orderId, userData) {
  return fetchExtraProductOfferInfo([itemData.productId])
    .then((extraInfo) => {
      const extraProductInfo = extraInfo[0] || {};
      return {
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': orderId,
              'userName': userData.name,
              'userEmail': userData.email,
              'price': itemData.price,
              'revenue': itemData.price,
              /** This values hardcoded for booking */
              'shipping': 0,
              'coupon': '',
            },
            'products': [{
              'id': itemData.id,
              'name': itemData.name,
              'price': itemData.price,
              'brand': BRAND_NAME,
              'category': extraProductInfo.elementSectionPath,
              'categoryId': extraProductInfo.elementSectionId,
              'variant': extraProductInfo.size,
              /** This values hardcoded for booking */
              'quantity': '1',
              'count': '1',
            }]
          }
        },
        'event': 'gtm-ee-event',
        'gtm-ee-event-category': 'Enhanced Ecommerce',
        'gtm-ee-event-action': 'Purchase',
        'gtm-ee-event-non-interaction': 'False',
      };
    });
}